export const channelListRoutes = {
  path: '',
  name: 'ChannelList',
  component: () => import('@/views/channel/index.vue'),
  meta: {
    hidden: false,
    title: 'Channel list',
    activeMenu:'/channel'
  }
}

export const tournamentConfigRoutes = {
  path: 'config',
  name: 'TournamentConfig',
  component: () => import('@/views/channel/tournamentConfig/index.vue'),
  meta: {
    hidden: false,
    title: 'Tournament Config',
    activeMenu:'/channel'
  }
}

// export const templateHistoryRoutes = {
//   path: 'templateHistory',
//   name: 'TemplateHistory',
//   component: () => import('@/views/channel/levelTemplate/history.vue'),
//   meta: {
//     hidden: false,
//     title: 'TemplateHistory',
//     activeMenu: '/channel'
//   }
// }

// export const channelHistoryRoutes = {
//   path: 'channelHistory',
//   name: 'ChannelHistory',
//   component: () => import('@/views/channel/channelList/history.vue'),
//   meta: {
//     hidden: false,
//     title: 'ChannelHistory',
//     activeMenu: '/channel'
//   }
// }
